<template>
  <div class="shop-user">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商铺保用户</span>
      </div>
      
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="自定义检索">
            <el-select v-model="searchType" placeholder="请选择" @change="handleSearchTypeChange">
              <el-option label="按公司名称" value="1" />
              <el-option label="按手机号码" value="2" />
              <el-option label="按注册时间" value="4" />
              <el-option label="按平台名称" value="6" />
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '1'">
            <el-input v-model="searchForm.companyName" placeholder="公司名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '2'">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '4'">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item v-if="searchType === '6'">
            <el-select v-model="searchForm.appId" placeholder="请选择平台">
              <el-option
                v-for="item in appList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-input v-model="searchForm.channel" placeholder="渠道商" clearable></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">全部</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="company_name" label="公司" width="280" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.company_id > 0" class="company-link" @click="viewCompanyDetail(scope.row.company_id)">
              {{ scope.row.company_name }}
            </span>
            <span v-else>{{ scope.row.company_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="180" align="center"></el-table-column>
        <el-table-column prop="app_name" label="平台名称" width="200" align="center"></el-table-column>
        <el-table-column prop="expense" label="消费金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="balance" label="账户余额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="created_at" label="注册时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="disabled" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
              {{ scope.row.disabled ? '锁定' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.disabled"
              size="mini"
              type="success"
              @click="handleUpdateStatus(scope.row.id, false, scope.row.mobile)">
              解锁
            </el-button>
            <template v-else>
              <el-button size="mini" type="warning" @click="handleUpdateStatus(scope.row.id, true, scope.row.mobile)">锁定</el-button>
              <el-button v-if="scope.row.company_id > 0" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;">
      </el-pagination>
      
      <!-- 编辑用户对话框 -->
      <EditUser
        :visible.sync="editDialogVisible"
        :user-data="currentUser"
        @success="handleEditSuccess"
        @close="editDialogVisible = false"
      />
    </el-card>
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { spbUserList, disabledSpbUser, getAppList, getChannelList } from '@/api/member'
import EditUser from './spbComponents/EditUser.vue'

export default {
  name: 'ShopUser',
  components: {
    EditUser
  },
  data() {
    return {
      loading: false,
      searchType: '1',
      searchForm: {
        companyName: '',
        mobile: '',
        dateRange: [],
        appId: '',
        channel: ''
      },
      tableData: [],
      multipleSelection: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      appList: [],
      channelList: [],
      editDialogVisible: false,
      currentUser: {}
    }
  },
  created() {
    this.fetchData()
    this.fetchAppList()
    this.fetchChannelList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          ...this.buildSearchParams()
        }
        
        const res = await spbUserList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取商铺保用户列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      switch (this.searchType) {
        case '1':
          if (this.searchForm.companyName) {
            params.company_name = this.searchForm.companyName
          }
          break
        case '2':
          if (this.searchForm.mobile) {
            params.mobile = this.searchForm.mobile
          }
          break
        case '4':
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
            params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
          }
          break
        case '6':
          if (this.searchForm.appId) {
            params.app_id = this.searchForm.appId
          }
          break
      }
      
      if (this.searchForm.channel) {
        // 这里需要根据实际需求处理渠道搜索
        params.channel_name = this.searchForm.channel
      }
      
      return params
    },
    
    // 获取平台列表
    async fetchAppList() {
      try {
        const res = await getAppList()
        this.appList = res.rows || []
      } catch (error) {
        console.error('获取平台列表失败:', error)
      }
    },
    
    // 获取渠道列表
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },
    
    // 搜索类型变化
    handleSearchTypeChange() {
      // 重置搜索表单
      this.searchForm.companyName = ''
      this.searchForm.mobile = ''
      this.searchForm.dateRange = []
      this.searchForm.appId = ''
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        companyName: '',
        mobile: '',
        dateRange: [],
        appId: '',
        channel: ''
      }
      this.searchType = '1'
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 导出Excel
    async handleExportExcel() {
      this.$message.info('导出Excel功能待实现')
    },
    
    // 查看公司详情
    viewCompanyDetail(companyId) {
      this.$message.info(`查看公司详情，ID: ${companyId}`)
    },
    
    // 编辑
    handleEdit(row) {
      this.currentUser = row
      this.editDialogVisible = true
    },
    
    // 编辑成功回调
    handleEditSuccess() {
      this.editDialogVisible = false
      this.fetchData()
    },
    
    // 更新状态（锁定/解锁）
    async handleUpdateStatus(userId, status, userName) {
      try {
        // 显示确认对话框，与spbprod项目保持一致
        const tip = status ? '锁定' : '解锁';
        await this.$confirm(`您确认想要修改用户 ${userName} 的状态为"${tip}"吗？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 调用API接口更新用户状态
        const params = {
          user_id: userId,
          disabled: status
        };
        
        const res = await disabledSpbUser(params);
        if (res.err_code === 0) {
          this.$message.success('修改成功')
          // 重新加载数据
          this.fetchData()
        } else {
          this.$message.error('修改失败: ' + res.err_msg)
        }
      } catch (error) {
        // 用户取消操作或API调用失败
        if (error !== 'cancel') {
          console.error('操作失败:', error)
          this.$message.error('操作失败: ' + (error.message || '未知错误'))
        }
      }
    },
    
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    
    // 金额格式化
    moneyFormat(row, column, cellValue) {
      return formatMoney(cellValue)
    },
    
    // 日期格式化
    dateFormat(row, column, cellValue) {
      return formatDate(cellValue)
    }
  }
}
</script>

<style lang="less" scoped>
.shop-user {
  padding: 20px;
  
  .search-toolbar {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .company-link {
    color: #409EFF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>